import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

import { useAppSelector } from "../../redux";
import { useNavigation } from "../../hooks/useNavigation";
import { useEffectiveOrganization } from "../../hooks/useEffectiveOrganization";
import { View, Spinner } from "../base";

type RequireAuthProps = {
  children: React.ReactNode;
  requireAdmin?: boolean;
  className?: string;
};

export const RequireAuth = ({ children, requireAdmin = false }: RequireAuthProps) => {
  const navigation = useNavigation();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const user = useAppSelector((state) => state.session.user);
  const { organization } = useEffectiveOrganization();
  const isLoading = useAppSelector((state) => state.session.isLoadingSession);

  useEffect(() => {
    if (!isLoading) {
      if (!user) {
        const params = new URLSearchParams();

        searchParams.forEach((value, key) => {
          params.append(key, value);
        });

        if (pathname === "/signout") {
          navigation.navigate("/signin");
        } else {
          navigation.navigate(`/signin?returnUrl=${pathname}?${params.toString()}`);
        }
      } else if (requireAdmin && !user.isAdmin) {
        navigation.navigate("/");
      }
    }
  }, [user, isLoading, requireAdmin]);

  if (isLoading || !user || (!organization && user.emailVerified !== false) || (requireAdmin && !user.isAdmin)) {
    return (
      <View className="flex items-center justify-center w-full h-full">
        <Spinner className="!text-brand" />
      </View>
    );
  }

  return <>{children}</>;
};
